'use client';

import { useEffect, useState } from 'react';
import styles from './NavigationLoader.module.css';

// Envelope opens, a signed card rises out, hearts drift up — shown over the page
// while a slow route change is in flight (driven by NavigationProgress).

const CAPTIONS = [
  'Gathering everyone’s wishes…',
  'Sealing it with love…',
  'Adding a little sparkle…',
  'Almost there…',
];

const HEART_PATH =
  'M12 21s-7.5-4.6-9.7-9.3C.6 8.2 2.7 4 6.6 4c2.2 0 3.6 1.2 5.4 3.2C13.8 5.2 15.2 4 17.4 4c3.9 0 6 4.2 4.3 7.7C19.5 16.4 12 21 12 21z';

function Heart({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={HEART_PATH} />
    </svg>
  );
}

export default function NavigationLoader({ visible }: { visible: boolean }) {
  const [captionIndex, setCaptionIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCaptionIndex((i) => (i + 1) % CAPTIONS.length), 1800);
    return () => clearInterval(id);
  }, []);

  return (
    <div role="status" aria-live="polite" className={`${styles.overlay} ${visible ? styles.visible : ''}`}>
      <div className={styles.panel}>
        <div className={styles.scene} aria-hidden="true">
          <div className={styles.back} />
          <div className={styles.card}>
            <Heart className={styles.cardHeart} />
            <div className={styles.line} />
            <div className={styles.line} />
            <div className={styles.line} />
          </div>
          <div className={styles.front} />
          <div className={styles.flap} />
          <div className={styles.seal}>
            <Heart />
          </div>
          <Heart className={styles.float} />
          <Heart className={styles.float} />
          <Heart className={styles.float} />
          <Heart className={styles.float} />
        </div>

        <p key={captionIndex} className={styles.caption}>
          {CAPTIONS[captionIndex]}
        </p>
        <div className={styles.dots} aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
